import { Component, OnInit } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { EditDataTypeComponent } from "../dialogs/edit-data-type/edit-data-type.component";
import { MatDialog } from "@angular/material/dialog";
import { DataTypeAccessRightsComponent } from "../dialogs/data-type-access-rights/data-type-access-rights.component";

@Component({
  selector: "app-data-type",
  templateUrl: "./data-type.component.html",
  styleUrls: ["./data-type.component.scss"],
})
export class DataTypeComponent implements OnInit {
  dataType: string | null = null;
  metadataExpanded: boolean = false;
  displayedColumns: string[] = [
    "allowedValue",
    "lock",
    "actions",
    "description",
  ];

  constructor(private route: ActivatedRoute, private dialog: MatDialog) {}

  ngOnInit(): void {
    this.dataType = this.route.snapshot.paramMap.get("dataType");
    console.log("Data type:", this.dataType);
  }
  toggleMetadata(): void {
    this.metadataExpanded = !this.metadataExpanded;
  }

  allowedValues = [
    {
      allowedValue: "ICAO",
      description: "ICAO 5 letter name code designator.",
    },
    {
      allowedValue: "COORD",
      description:
        "Point with identifier derived from its geographic coordinates.",
    },
    {
      allowedValue: "CNF",
      description: "Computer Navigation Fix - A point used for navigation.",
    },
    {
      allowedValue: "DESIGNED",
      description: "A point with bearing/distance designator used.",
    },
    {
      allowedValue: "MTR",
      description: "Point used on a military training route.",
    },
    {
      allowedValue: "TERMINAL",
      description: "Point with a five-alphanumeric name-code.",
    },
    {
      allowedValue: "BRG_DIST",
      description: "Point with a five-alphanumeric name-code.",
    },
    { allowedValue: "OTHER:VRP", description: "VFR reporting point." },
  ];

openDialog(element?: any): void {
  const dialogRef = this.dialog.open(EditDataTypeComponent, {
    width: '600px',
    data: {
      dataType: this.dataType,
      element: element ? { ...element } : null,
    },
  });

  dialogRef.afterClosed().subscribe((result) => {
    if (result) {
      if (element) {
        Object.assign(element, result);
      } else {
        this.allowedValues.push(result);
      }

      // ✅ Samo sortira OTHER* međusobno, ostale ne dira
      const nonOther = this.allowedValues.filter(
        v => !v.allowedValue.startsWith('OTHER')
      );
      const other = this.allowedValues
        .filter(v => v.allowedValue.startsWith('OTHER'))
        .sort((a, b) => a.allowedValue.localeCompare(b.allowedValue));

      this.allowedValues = [...nonOther, ...other];
    }
  });
}


  openAccess(allowedValue: string): void {
    const dialogRef = this.dialog.open(DataTypeAccessRightsComponent, {
      width: "800px",
      data: { value: allowedValue, dataType: this.dataType },
    });

    dialogRef.afterClosed().subscribe((result) => {
      console.log("Dijalog zatvoren, rezultat:", result);
    });
  }
}
